import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcbservicefrommumbai() {



  const cardData =
  {
    keyword: 'Outstation Cab Services from Mumbai',
    heading: 'Aaryan Travels: Outstation Cab Services from Mumbai',
    headingDescription: ' Aaryan Travels offers dependable Outstation Cab Services from Mumbai for weekend getaways, family tours, pilgrimage trips, and corporate travel across Maharashtra and beyond. Whether you are heading to Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Ahmedabad, or any long-distance destination, our fleet of sedans, SUVs, and tempo travellers ensures a safe and comfortable journey. With experienced chauffeurs, 24/7 booking support, and flexible one-way or round-trip packages, we make intercity travel effortless and affordable. From South Mumbai to Thane and Navi Mumbai, Aaryan Travels provides doorstep pickup and reliable outstation cab rentals for individuals, families, and business travelers alike.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 overlooking the Arabian Sea, the Gateway of India is Mumbai’s most iconic monument. It served as a ceremonial entrance during British rule. Tourists gather to enjoy ferry rides to Elephanta Caves and soak in coastal views. Street vendors and bustling crowds add to the lively atmosphere. The Gateway of India is Mumbai’s timeless symbol of pride."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, popularly known as the Queen’s Necklace, is a 3.6 km-long curved boulevard lined with palm trees and sea views. At night, the streetlights resemble a dazzling necklace. Locals and tourists come for morning jogs, sunset views, and roadside chai. The ocean breeze adds a refreshing charm. Marine Drive is Mumbai’s classic seaside escape."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, CST is a stunning example of Victorian Gothic Revival architecture built in 1887. Its stained glass windows, domes, and intricate carvings resemble a palace more than a railway station. Thousands commute daily through its historic halls. Illuminated beautifully at night, it becomes a visual masterpiece. CST is Mumbai’s living monument of heritage and functionality."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal hangouts known for its local street food like pav bhaji, bhel puri, and kulfi. Families enjoy camel rides, sand play, and lively evenings. Nearby luxury hotels and celebrity houses add glamour. Sunset walks here are unforgettable. Juhu Beach is Mumbai’s fun-loving seaside paradise."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Situated on a tiny islet in the Arabian Sea, Haji Ali Dargah is a 15th-century mosque and tomb accessible via a narrow pathway during low tide. The white marble structure appears to float on water, creating a magical view. Devotees from all faiths visit for blessings and qawwali music. Haji Ali is Mumbai’s serene symbol of unity and spirituality."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these UNESCO-listed rock-cut caves date back to the 5th century. The main cave features grand sculptures of Lord Shiva, including the famous three-faced Trimurti. Visitors reach the site via ferry from Gateway of India. Surrounded by lush greenery and ancient art, it feels like a journey through time. Elephanta Caves are Mumbai’s heritage wonder."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Dedicated to Lord Ganesha, Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines. Celebrities, politicians, and locals offer prayers daily. The gold-plated dome and peaceful interiors offer spiritual calm. Tuesdays see massive crowds of devotees. Siddhivinayak is Mumbai’s divine center of devotion and hope."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed marvel connecting South Mumbai to the Western Suburbs. Driving across offers panoramic sea views and Mumbai’s skyline. Lit up at night, it becomes a futuristic spectacle. It has reduced travel time significantly while enhancing the city’s modern identity. The Sea Link is Mumbai’s engineering icon."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street market famous for clothes, jewelry, antiques, and souvenirs. Iconic cafés like Leopold and Café Mondegar add to the retro vibe. Tourists bargain for quirky finds while enjoying vibrant street life. It is a must-visit for shoppers and explorers. Colaba Causeway is Mumbai’s colorful shopping hub."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering dense greenery, caves, and wildlife safaris. Kanheri Caves inside the park showcase ancient Buddhist rock-cut structures. Visitors enjoy trekking, cycling, and toy train rides through nature. Deer, butterflies, and birds are commonly spotted. SGNP is Mumbai’s natural escape from the chaos."
  }
],


 "services": [
  {
    "name": "Outstation Cab Services from Mumbai",
    "description": "Our Outstation Cab Services from Mumbai offer reliable and comfortable long-distance travel solutions to nearby cities and towns. Whether it's for business trips, family outings, or weekend getaways, our fleet of well-maintained sedans and SUVs ensures a safe and pleasant journey with professional drivers familiar with the best routes."
  },
  {
    "name": "Mumbai Outstation Taxi",
    "description": "Mumbai Outstation Taxi provides convenient taxi services for out-of-city travel. We offer flexible booking options including one-way and round-trip services, catering to your travel needs with punctual pickups and courteous drivers to ensure a hassle-free experience."
  },
  {
    "name": "Long Distance Cab from Mumbai",
    "description": "Travel long distances comfortably with our Long Distance Cab service from Mumbai. Our spacious vehicles and professional chauffeurs guarantee safe, timely journeys to destinations beyond Mumbai, perfect for both business and leisure travelers."
  },
  {
    "name": "Mumbai to Nearby City Cab",
    "description": "Our Mumbai to Nearby City Cab service offers quick and affordable rides to surrounding cities. Ideal for day trips, client meetings, or family visits, we ensure prompt service with clean, well-maintained cars and experienced drivers."
  },
  {
    "name": "Book Outstation Cab Mumbai",
    "description": "Book Outstation Cab Mumbai provides an easy and efficient online booking platform to schedule your outstation rides. Choose from a variety of vehicle options, track your ride, and enjoy seamless customer support for a smooth travel experience."
  },
  {
    "name": "Affordable Outstation Cab Mumbai",
    "description": "Affordable Outstation Cab Mumbai focuses on delivering cost-effective outstation travel solutions without compromising on comfort or safety. Enjoy competitive pricing with reliable services tailored to your budget."
  },
  {
    "name": "Mumbai Intercity Taxi",
    "description": "Mumbai Intercity Taxi connects you with neighboring cities through dependable and timely taxi services. Our drivers are experienced in long routes and ensure a comfortable ride, whether it’s a business visit or a leisure trip."
  },
  {
    "name": "Out-of-Town Cab Mumbai",
    "description": "Out-of-Town Cab Mumbai offers flexible taxi services for travel outside the city limits. With a range of vehicles and professional drivers, we cater to weekend trips, business excursions, and special events requiring outstation travel."
  },
  {
    "name": "Round Trip Cab Mumbai",
    "description": "Our Round Trip Cab Mumbai service provides hassle-free round-trip bookings for your outstation travels. Enjoy the convenience of a dedicated vehicle and driver for the entire duration of your trip, ensuring flexibility and peace of mind."
  },
  {
    "name": "One Way Outstation Cab Mumbai",
    "description": "One Way Outstation Cab Mumbai offers economical and efficient one-way rides to your outstation destinations. Ideal for travelers looking for point-to-point service with transparent pricing and professional drivers."
  },
  {
    "name": "Sedan Outstation Mumbai",
    "description": "Sedan Outstation Mumbai features comfortable sedans perfect for small groups or solo travelers venturing out of the city. Our air-conditioned sedans are well-maintained to provide a smooth and relaxing journey."
  },
  {
    "name": "SUV Outstation Cab Mumbai",
    "description": "SUV Outstation Cab Mumbai offers spacious and sturdy SUVs suitable for families or groups traveling longer distances. Experience enhanced comfort and safety with our expert drivers and premium vehicles."
  },
  {
    "name": "Luxury Outstation Cab Mumbai",
    "description": "Travel in style with our Luxury Outstation Cab Mumbai service, featuring premium cars and exceptional chauffeur service. Ideal for corporate travelers or special occasions, we provide a high-end experience for your long-distance trips."
  },
  {
    "name": "Corporate Outstation Cab Mumbai",
    "description": "Corporate Outstation Cab Mumbai is tailored to meet the needs of business travelers requiring reliable and professional outstation transportation. Benefit from flexible packages, professional chauffeurs, and seamless booking for your corporate journeys."
  },
  {
    "name": "Weekend Trip Cab Mumbai",
    "description": "Weekend Trip Cab Mumbai offers convenient and comfortable cab services designed for short weekend getaways. Choose from sedans and SUVs with flexible timings to make your weekend trips relaxing and enjoyable."
  }
],
"tableData": [
  ["Outstation Cab Services from Mumbai", "Mumbai Outstation Taxi"],
  ["Long Distance Cab from Mumbai", "Mumbai to Nearby City Cab"],
  ["Book Outstation Cab Mumbai", "Affordable Outstation Cab Mumbai"],
  ["Mumbai Intercity Taxi", "Out-of-Town Cab Mumbai"],
  ["Round Trip Cab Mumbai", "One Way Outstation Cab Mumbai"],
  ["Sedan Outstation Mumbai", "SUV Outstation Cab Mumbai"],
  ["Luxury Outstation Cab Mumbai", "Corporate Outstation Cab Mumbai"],
  ["Weekend Trip Cab Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Outstation Cab Services from Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers reliable and comfortable outstation cab services starting from Mumbai to various destinations."
  },
  {
    "WhyChooseheading": "Convenient Pickup from Anywhere in Mumbai",
    "WhyChoosedescription": "Our drivers ensure timely pickups from your preferred location within Mumbai for hassle-free travel."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Long Journeys",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars designed for your comfort and safety on outstation trips."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Long-Distance Routes",
    "WhyChoosedescription": "Our professional drivers know the highways and routes well to ensure efficient and safe travel."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Outstation Travel",
    "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Smooth Booking and Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options Tailored to Your Travel Needs",
    "WhyChoosedescription": "Choose from point-to-point rides, round trips, or hourly rentals for your outstation journey."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Group Size and Preferences",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your comfort and luggage requirements."
  }
]





































  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide outstation cab services from Mumbai?',
    answer: 'Yes, Aaryan Travels offers reliable and comfortable outstation cab services from Mumbai to various destinations.',
  },
  {
    question: 'How can I book outstation cab services from Mumbai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for outstation trips from Mumbai?',
    answer: 'We offer a range of vehicles including sedans, SUVs, and luxury cars to suit your travel preferences.',
  },
  {
    question: 'Are drivers experienced and knowledgeable about outstation routes from Mumbai?',
    answer: 'Absolutely. Our drivers are professional, licensed, and familiar with routes to popular outstation destinations from Mumbai.',
  },
  {
    question: 'Can I hire outstation cabs for one-way or round trips from Mumbai?',
    answer: 'Yes, Aaryan Travels provides both one-way and round-trip outstation cab services from Mumbai.',
  },
  {
    question: 'Is outstation cab service from Mumbai available 24x7?',
    answer: 'Yes, we offer 24x7 booking and services for outstation cabs from Mumbai.',
  },
  {
    question: 'What safety and hygiene measures are followed for outstation cabs from Mumbai?',
    answer: 'All vehicles are sanitized regularly, and our drivers adhere to strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Are there any kilometer limits for outstation cab services from Mumbai?',
    answer: 'We offer flexible packages including unlimited kilometers depending on your travel plan.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for outstation cabs from Mumbai?',
    answer: 'Yes, you can specify your preferred pickup and drop locations as per your travel itinerary.',
  },
  {
    question: 'What payment options are accepted for outstation cab bookings from Mumbai?',
    answer: 'We accept cash, cards, UPI, and popular digital wallets for easy payments.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vivek Joshi',
    feedback: 'Aaryan Travels provided a smooth and comfortable outstation cab service from Mumbai. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Nair',
    feedback: 'Great service and well-maintained cars for outstation trips from Mumbai. Will definitely book again.',
    rating: 5,
  },
];
































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Cab Services from Mumbai",
  "image": "https://aaryantravels.com/assets/images/outstation-cab-services-from-mumbai.jpg", // replace with actual image URL
  "description": "Aaryan Travels offers reliable and affordable outstation cab services from Mumbai. Choose from sedan, SUV, and luxury cabs for one-way or round trips to popular destinations near Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // example rating
    "ratingCount": "3900", // example count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",  // example base fare
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/outstation-cab-services-from-mumbai"
  }
};








  return (
    <div>

<Helmet>
  <title>Outstation Cab Services from Mumbai | Reliable & Affordable Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Aaryan Travels offers reliable and affordable outstation cab services from Mumbai. Choose from sedan, SUV, and luxury cabs for one-way or round trips to popular destinations near Mumbai."
  />
  <meta
    name="keywords"
    content="Outstation Cab Services from Mumbai, Mumbai Outstation Taxi, Long Distance Cab from Mumbai, Mumbai to Nearby City Cab, Book Outstation Cab Mumbai, Affordable Outstation Cab Mumbai, Mumbai Intercity Taxi, Out-of-Town Cab Mumbai, Round Trip Cab Mumbai, One Way Outstation Cab Mumbai, Sedan Outstation Mumbai, SUV Outstation Cab Mumbai, Luxury Outstation Cab Mumbai, Corporate Outstation Cab Mumbai, Weekend Trip Cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcbservicefrommumbai;